import LottieAnimation from '@CS/components/LottieAnimation';
import { Loader as Assets } from '@CS/assets';
import CSS from './Loader.module.css';
import Particles from '@CS/components/Particles';

export type LoaderProps = {
  opacity?: number;
  image?: string;
  color?: string;
  lottie?: JSON;
  size?: number;
};

export const Loader = ({
  // color = 'white',
  opacity = 0.0,
  size = 50,
  lottie,
  image
}: LoaderProps) => (
  <aside
    className={CSS.loaderContainer}
    style={{ backgroundColor: `rgb(0 0 0 / ${opacity})` }}
  >
    {lottie ? (
      <div className={CSS.imageContainer} style={{ width: `${size}px` }}>
        <LottieAnimation animationData={Assets.lottie} />
      </div>
    ) : image ? (
      <div className={CSS.imageContainer} style={{ width: `${size}px` }}>
        <img src={Assets.gif} />
      </div>
    ) : (
      <Particles autoplay />
    )}
  </aside>
);
